export const GET_VEHICLE_PACKAGE_LOGS = "GET_VEHICLE_PACKAGE_LOGS";
export const ADD_VEHICLE_PACKAGE_LOGS = "ADD_VEHICLE_PACKAGE_LOGS";
export const EDIT_VEHICLE_PACKAGE_LOGS = "EDIT_VEHICLE_PACKAGE_LOGS";
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'

